import { Plus, Trash2 } from 'lucide-react';
import React from 'react';
import { permissions as permifyPermissions } from '../../../../../../api/src/permify/constants';

import { ConfirmationDialog } from '@repo/ui/components/ui/confirmation-dialog';
import { cn } from '@repo/ui/lib/utils';
import { ViewMode } from '@repo/ui/state';
import { Button } from '../../../ui/button';

type HeaderActionButtonsProps = {
  viewMode: ViewMode;
  loading: boolean;
  error?: string | null;
  dismissedCount: number;
  canCreateStage: boolean;
  onDismissedFolderClick: () => void;
  onNewStageClick: () => void;
};

export const HeaderActionButtons: React.FC<HeaderActionButtonsProps> = ({
  viewMode,
  loading,
  error,
  dismissedCount,
  onDismissedFolderClick,
  onNewStageClick,
  canCreateStage,
}) => (
  <div
    data-testid="top-right-container"
    className={cn(
      'items-center',
      viewMode === ViewMode.SELECT ? 'hidden md:flex' : 'flex',
    )}
  >
    {viewMode === ViewMode.VIEW && (
      <>
        <Button
          disabled={loading || !!error}
          variant="ghost"
          data-permission={permifyPermissions.openCalls.removeCandidates}
          className="hidden md:flex text-red-600 hover:text-red-500 hover:underline hover:bg-transparent"
          onClick={onDismissedFolderClick}
        >
          Dismissed Folder ({dismissedCount})
        </Button>
        <Button
          variant="ghost"
          disabled={loading || !!error}
          data-permission={permifyPermissions.openCalls.removeCandidates}
          className="md:hidden text-red-600 hover:text-red-500 hover:bg-transparent"
          onClick={onDismissedFolderClick}
        >
          <Trash2 />
        </Button>

        {canCreateStage && (
          <ConfirmationDialog
            action={onNewStageClick}
            actionName="Create new stage"
            description="Once this new stage is added, it cannot be deleted later."
            title="Create a new stage?"
            permission={permifyPermissions.openCalls.manageStages}
          >
            <Button
              className="flex items-center"
              data-permission={permifyPermissions.openCalls.manageStages}
            >
              <span className="hidden md:block">New Stage</span>
              <Plus />
            </Button>
          </ConfirmationDialog>
        )}
        {!canCreateStage && (
          <ConfirmationDialog
            action={() => {}}
            actionName="Got it"
            description="Only 3 new stages per casting call can be created."
            title="Cannot create new stage"
            permission={permifyPermissions.openCalls.manageStages}
          >
            <Button
              className="flex items-center"
              data-permission={permifyPermissions.openCalls.manageStages}
            >
              <span className="hidden md:block">New Stage</span>
              <Plus />
            </Button>
          </ConfirmationDialog>
        )}
      </>
    )}
  </div>
);
